import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SContactComponent } from './s-contact.component';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '@app/@shared';
import { Shell } from '@app/shell/shell.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

const routes: Routes = [
  Shell.childRoutes([{ path: 'contact-us', component: SContactComponent, data: { title: marker('Contact') } }]),
];

@NgModule({
  declarations: [SContactComponent],
  imports: [CommonModule, SharedModule, RouterModule.forChild(routes)],
})
export class SContactModule {}
